import { render } from "./StatsModal.vue?vue&type=template&id=2592234b&scoped=true"
import script from "./StatsModal.vue?vue&type=script&lang=js"
export * from "./StatsModal.vue?vue&type=script&lang=js"

import "./StatsModal.vue?vue&type=style&index=0&id=2592234b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2592234b"]])

export default __exports__